module.exports = __webpack_public_path__ + "static/media/imageLeft.a03cfa38.png";